import { observer } from "mobx-react";
import currentPortalStore from "../../../../../stores/current-portal-store";
import PortalEdgeFontsAndColorsCard from "./portal-edge-fonts-and-colors-card";
import PortalClassicFontsAndColorsCard from "./portal-classic-fonts-and-colors-card";
import { useState } from "react";

const FontsAndColorsCard: React.FC = observer(() => {
    const enablePortalV2 = currentPortalStore.setting?.enablePortalV2;
    const [isExpanded, setIsExpanded] = useState(false);

    if (enablePortalV2) {
        return (
            <PortalEdgeFontsAndColorsCard
                isExpanded={isExpanded}
                onExpandedChange={setIsExpanded}
            />
        );
    }

    return (
        <PortalClassicFontsAndColorsCard
            isExpanded={isExpanded}
            onExpandedChange={setIsExpanded}
        />
    );
});

export default FontsAndColorsCard;
